module.exports = __webpack_public_path__ + "static/media/add student talent.56a3c189.svg";